import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobile, faStar } from "@fortawesome/free-solid-svg-icons";
import { faGooglePlay, faAppStore } from "@fortawesome/free-brands-svg-icons";

import styles from "./OverviewCard.module.scss";

const iconMap = {
	faMobile: faMobile,
	faGooglePlay: faGooglePlay,
	faAppStore: faAppStore,
	faStar: faStar,
};

export const OverviewCard = ({ icon, label, value }) => {
	const selectedIcon = iconMap[icon];

	if (!selectedIcon) {
		console.warn(`Icon "${icon}" not found in iconMap`);
		return null;
	}

	return (
		<div className={styles.overviewCard}>
			<div className={styles.overviewCard__iconContainer}>
				<FontAwesomeIcon icon={selectedIcon} size="lg" color="#fff" />
			</div>
			<div className={styles.overviewCard__details}>
				<div className={styles.overviewCard__label}>{label}</div>
				<div className={styles.overviewCard__value}>{value}</div>
			</div>
		</div>
	);
};
